import {
  eolsBaseApi,
  withApiErrorLoggingOnly
} from '../../utilities/api.utilities';
import { addSearchParams } from '../../utilities/app.utilities';

export const fetchSaiActiveIsbns = (isbns: string[]): Promise<Record<string, boolean>> => {
  return withApiErrorLoggingOnly(() => {
    return eolsBaseApi.getWithoutApiString(addSearchParams('/nacs/chat/sherpath-ai-active-isbns', { isbns }));
  });
};
